import type { FaireProductEntity } from "../../entity_types/product";

export const p_20ihn4x3: FaireProductEntity = {
  token: "p_20ihn4x3",
  type: "product",
  name: "Thank You Bag",
  brandToken: "b_5lgyja8g",
  brandName: "a. favorite design",
  imageUrl:
    "https://cdn.faire.com/fastly/38f90289ba24c6ecad452ae51c691a975acbf724f0a1a6b11b258db66080d3e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05d7dbb848ce77be29e9c90f7c17fc731af3e8d471b25199d2970ca7b6a291e2.jpeg",
    "https://cdn.faire.com/fastly/b911dc15d864b6a0da5ba31982aad4a54c791e84fdd376699a75a4002a032461.jpeg",
  ],
  priceDollars: 3,
  description:
    "Nothing says thank you like the ever famous generic, plastic thank you bag seen across America. This note is inspired by the iconic design.\n\n• 1 color letterpress printed\n• bright white cover stock\n• bright white envelope\n• blank inside",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:11.645Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
